import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import useUser from '../hooks/global/useUser';

export default function NoImpersonationPage() {
  const navigate = useNavigate();
  const { user } = useUser();

  React.useEffect(() => {
    if (user?.business) {
      navigate('/');
    }
  }, [navigate, user]);

  return (
    <Box
      p={4}
      boxSizing="border-box"
      sx={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInline: '1rem',
      }}>
      <Stack spacing={3} maxWidth={520} alignItems="center">
        <Typography variant="h1" align="center">
          No active impersonation
        </Typography>
        <Typography variant="body1" align="center">
          You&apos;re signed in as a Porter admin. Start an impersonation from
          the admin dashboard to access a shop.
        </Typography>
        <Button
          variant="text"
          onClick={() => auth.signOut().then(() => navigate('/'))}>
          Sign out
        </Button>
      </Stack>
    </Box>
  );
}
